import { render, staticRenderFns } from "./comfortSlider.vue?vue&type=template&id=d8f2bc6a"
import script from "./comfortSlider.vue?vue&type=script&lang=js"
export * from "./comfortSlider.vue?vue&type=script&lang=js"
import style0 from "./comfortSlider.vue?vue&type=style&index=0&id=d8f2bc6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports